var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup3841 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(0.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-0.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M5.625,0h.75c.077.01.153.02.23.029A5.888,5.888,0,0,1,9.778,1.346a5.9,5.9,0,0,1,2.13,3.62c.039.218.062.439.092.659v.75c-.018.147-.034.293-.055.44a6.023,6.023,0,0,1-4.9,5.092c-.222.04-.446.063-.67.093h-.75c-.146-.018-.293-.034-.439-.055a6.025,6.025,0,0,1-5.092-4.9C.053,6.823.031,6.6,0,6.375v-.75c.018-.147.033-.293.054-.44A5.918,5.918,0,0,1,1.72,1.8,5.876,5.876,0,0,1,4.967.092C5.185.054,5.405.03,5.625,0M6,11.25A5.25,5.25,0,1,0,.75,6,5.259,5.259,0,0,0,6,11.25",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M180,72.148h.781v.146q0,1.746,0,3.492a.258.258,0,0,0,.084.2q1.03,1.024,2.055,2.052a1.231,1.231,0,0,0,.1.08l-.561.56c-.016-.015-.04-.036-.063-.058q-1.161-1.161-2.32-2.324a.248.248,0,0,1-.071-.155q-.006-1.961,0-3.921c0-.02,0-.04,0-.074",
    transform: "translate(-174.457 -70.006)",
    fill: "#0d47a1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup3841);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 3841.c6b1d04dc55c062548debdcd2072812b.svg";